import $ from 'jquery';
import Version from './lib/Version';
import Messaging from './ui/Messaging';
import App from './App';
import FormButtonHandler from './handlers/FormButtonHandler';
import GoogleDataLayerProvider from './lib/GoogleDataLayerProvider';
import BodyKeyPressedClassHandler from './handlers/BodyKeyPressedClassHandler';
import AccountNavigation from '../utilityNav/AccountNavigation';
import AccountNavigationElements from '../utilityNav/AccountNavigationElements';
import CartTimerHandler from '../utilityNav/CartTimerHandler';
import CartTimerHandlerElements from '../utilityNav/CartTimerHandlerElements';
import PromoCodeProvider from '../utilityNav/PromoCodeProvider';
import PromoCodeProviderElements from '../utilityNav/PromoCodeProviderElements';
import MembershipPeriodMessagingDismissal from '../utilityNav/MembershipPeriodMessagingDismissal';
import MembershipPeriodMessagingDismissalElements from '../utilityNav/MembershipPeriodMessagingDismissalElements';
import shared from './shared';
import FormSubmitButton from '../forms/FormSubmitButton';
import { OnLoadFocusHandler } from './handlers/OnLoadFocusHandler';

BodyKeyPressedClassHandler.listen();

const formButtonHandler = new FormButtonHandler();
formButtonHandler.listen();

const app = new App();

OnLoadFocusHandler.listen();

const tnew = {
  app,
  page: {},
  lib: {
    Version,
    GoogleDataLayerProvider,
    events: {},
    api: {
      tnew: {
        account: {},
        system: {},
        products: {},
        cart: {
          payment: {},
        },
      },
    },
  },
  ui: {
    messaging: Messaging,
  },
  handlers: {
    formButtonHandler,
  },
  shared,
  pluginUtils: {
    FormSubmitButton,
  },
};

window.tnew = tnew;

PromoCodeProvider.init(PromoCodeProviderElements);
AccountNavigation.init(AccountNavigationElements);
MembershipPeriodMessagingDismissal.init(MembershipPeriodMessagingDismissalElements);

const cartTimerHandler = new CartTimerHandler(CartTimerHandlerElements);
shared.setCartTimerHandler(cartTimerHandler);
